<div class="datepicker__wrapper">
  <div class="datepicker__body">
    <div class="datepicker__wrapper__header">
      <div class="day__wrapper">
        <span
          [ngClass]="{ active: day.clicked == true }"
          *ngFor="let day of weekDayString; let i = index"
          class="selected__days"
          (click)="selectDay(i)"
          >{{ day.name | translate }}</span
        >
      </div>
      <div
        [ngClass]="timeError ? 'error' : ' '"
        class="datepicker__hour__wrapper"
      >
        <span class="icon__clock"></span>
        <ngb-timepicker [(ngModel)]="timeFrom"> </ngb-timepicker>
        <ngb-timepicker [(ngModel)]="timeTo"></ngb-timepicker>
      </div>
    </div>
    <ngb-datepicker
      #dp
      (dateSelect)="onDateSelection($event)"
      [displayMonths]="2"
      [dayTemplate]="t"
      outsideDays="hidden"
      navigation="arrows"
    >
    </ngb-datepicker>

    <ng-template #t let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
      >
        {{ date.day }}
      </span>
    </ng-template>
    <div class="datepicker__wrapper__footer text-right">
      <button
        type="button"
        type="button"
        class="button button--borderless button--small"
        (click)="resetPicker()"
      >
        {{ "Today" | translate }}
      </button>
      <button
        type="button"
        type="button"
        (click)="onClickDoneSchedule()"
        class="button button--purple button--small mr-3"
        [disabled]="editScheduleIsLoaded"
      >
        <span *ngIf="editScheduleIsLoaded"
          ><span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ "Saving" | translate }}</span
        ><span *ngIf="!editScheduleIsLoaded">{{ "Done" | translate }}</span>
      </button>
    </div>
  </div>
</div>
